import { uniq } from "lodash";
import { Dispatch, SetStateAction } from "react";
import RepCircle from "./RepCircle";
import { CloserFile, DepartmentForDashboard, CloserAndDepartment } from "./types";

const DepartmentReps = ({
  department,
  filesForDeparment,
  selectedCloserAndDepartment,
  setSelectedCloserAndDepartment
}: {
  department: DepartmentForDashboard;
  filesForDeparment: CloserFile[];
  selectedCloserAndDepartment: CloserAndDepartment;
  setSelectedCloserAndDepartment: Dispatch<SetStateAction<CloserAndDepartment>>;
}) => {
  const closersInDepartment = uniq(filesForDeparment?.map((f) => f.closer));
  return (
    <div key={department.name} className={`columnWrap ${department.repsClassName}`}>
      {closersInDepartment.map((closer) => {
        const orderCount = filesForDeparment.filter((f) => f.closer == closer).length || 0;
        const isSelected =
          selectedCloserAndDepartment.closer == closer && selectedCloserAndDepartment.department == department.name;
        return (
          <RepCircle
            key={closer}
            name={closer}
            orderCount={orderCount}
            isSelected={isSelected}
            onClick={() => {
              setSelectedCloserAndDepartment({ department: department.name, closer });
            }}
          />
        );
      })}
    </div>
  );
};
export default DepartmentReps;
